/* eslint-disable */
import { RouteConfig } from 'vue-router';
import Authentication from '@/modules/authentication/Authentication.vue';
import Users from '@/modules/authentication/views/Users.vue';

const routes: Array<RouteConfig> = [
  {
    path: '/authentication',
    name: 'Authentication',
    component: Authentication,
    redirect: { name: 'Users' },
    children: [
      {
        path: '/authentication/users',
        name: 'Users',
        component: Users,
        meta: {
          title: 'authentication.Users.metaTitle'
        }
      }
    ]
  }
];

export default routes;
